import Helper from "./helper";
import RoleHelper from "./roleHelper";
import { enumHttpError } from "../enums/enumHttpError";

export function handleDocumentDownload({
    currentUser,
    setDialogConnection,
    setDialogFreemiumInfo,
    displayFakeInformation,
    entrepriseId,
    etudiantId,
    creditActionEnum,
    documentId,
    documentName,
    documentService,
    entrepriseService,
    toast,
    t,
    onMissingCredits,
    onSuccess, // Callback pour notifier le succès
    onCreditUpdate, // Pour mettre à jour les crédits dans l'UI
    openMethod = "tab"
}) {
    if (RoleHelper.isNotConnected(currentUser)) {
        setDialogConnection(true);
    } else if (displayFakeInformation) {
        setDialogFreemiumInfo(true);
    } else {
        entrepriseService.checkAndConsumeCreditsForAction(entrepriseId, etudiantId, creditActionEnum)
            .then((creditResult) => {
                if (creditResult.hasEnoughCredits || creditResult.HasEnoughCredits) {
                    documentService.TelechargerDocumentCandidat(documentId).then(blob => {
                        if (openMethod === "window") {
                            Helper.openWindowBlobFile(blob, documentName);
                        } else if (openMethod === "download") {
                            Helper.downloadBlobFile(blob, documentName);
                        } else {
                            Helper.openPdfInNewTab(blob, documentName);
                        }
                        
                        const resultData = {
                            creditConsumed: creditResult.creditConsumed || creditResult.CreditConsumed || false,
                            creditsRemaining: (creditResult.creditsRemaining || creditResult.CreditsRemaining),
                            message: creditResult.message || creditResult.Message || t('general.document_downloaded_successfully')
                        };
                        
                        // Mise à jour des crédits dans l'UI
                        if (onCreditUpdate) {
                            onCreditUpdate({
                                available: resultData.creditsRemaining,
                                creditConsumed: resultData.creditConsumed
                            });
                        }
                        
                        if (onSuccess) {
                            onSuccess(resultData);
                        }
                    });
                } else {
                    if (onMissingCredits) {
                        onMissingCredits();
                    }
                }
            })
            .catch((err) => {
                if (err.message === enumHttpError.MISSINGCREDITS) {
                    if (onMissingCredits) {
                        onMissingCredits();
                    } else {
                        toast.current.show({
                            severity: 'error',
                            summary: t('general.error'),
                            detail: t('errors.not_enough_credit'),
                            life: 3000
                        });
                    }
                }
            });
    }
}
